module.exports = __webpack_public_path__ + "img/default_group_avatar.b5491442.svg";